<div *ngIf="message" class="alert-container margin-top"
  [ngClass]="{'mt24': notTop === false && closeFadeOut === false,  'close-div': closeFadeOut === true, 'open-div': closeFadeIn === true, 'ma-alert-container': !isAcmic, 'alert-box-shadow': message?.theme ==='white', 'manage-top': manageWallet, 'unenrolled-notification': message?.iconPath === 'assets/img/images/unenrolled-icon-info.svg','enrolled-notification': message?.type === 'success' && message?.title === 'You\'ve enrolled successfully!'}">
  <div class="fade" [class.show]="setFadeOut === false">
    <ng-container *ngIf="message?.type === 'errorButton'; else noButton">
        <ng-container *ngIf="isAcmic; else maErrorWithButton">
          <div class="mapfre alert error">    
            <div class="row a-cont">
              <div class="icon col agent_link">
                <div class="close-button-err">
                  <ng-container *ngIf="isAcmic; else nonAcmic">
                    <img alt="warning icon" src="assets/SVG/icon-warning-red.svg">
                  </ng-container>
                  <ng-template #nonAcmic>
                    <a (click)="closeMe('dynamic')">
                      <i class="far fa-times-circle"></i>
                    </a>
                  </ng-template>
                </div>
              </div>
              <div class="m col agent_link">
                <p class="alert-text">
                  {{ message?.text | translate }}
                </p>
                <div>
                  <mapfre-button additionalClasses="btn mapfre basic primary medium-btn red" [routerLink]="['/login']">
                    {{ "LOGIN" | translate }}
                  </mapfre-button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #maErrorWithButton>
          <div class="ma-alert-with-btn">
            <div class="row notice-content">
              <div class="imp-notice">
                <div class="icon-block">
                  <img src="./assets/img/images/icon-warning-red.svg">
                </div>
                <div class="imp-notice-content text-left">
                  <div class="imp-title mb-1">Email in use</div>
                  <div class="imp-para ">You might already have an active account.</div>
                  <div class="margin-top mt24">
                    <mapfre-button additionalClasses="btn mapfre basic primary medium-btn red" [routerLink]="['/login']">
                      {{ "LOGIN" | translate }}
                    </mapfre-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
    </ng-container>
    <ng-template #noButton>
      <!-- <ng-container *ngIf="!isAcmic; else acmicError">
        <ng-container *ngFor="let alertTypeObject of alertTypeObjects">
        <div class="notify-error">
          <div class="error-icon">
              <img src="./assets/SVG/icon-warning-error.svg">
          </div>
          <div class="error-info">
            <div class="err-info-text">{{ message?.text | translate }} </div>
            <div class="">
              <a (click)="closeMe('dynamic')">
                <img src="./assets/SVG/icon-close.svg">
              </a>
            </div>
          </div>
      </div>
      </ng-container>
      </ng-container>
      <ng-template #acmicError>       -->
      <ng-container *ngIf="message?.type === 'errorLink'; else noLink">
        <div class="mapfre alert error">
          <div class="row a-cont">
            <div class="icon col agent_link">
              <div class="close-button-err">
                <ng-container *ngIf="isAcmic; else nonAcmic">
                  <img alt="warning icon" src="assets/SVG/icon-warning-red.svg">
                </ng-container>
                <ng-template #nonAcmic>
                  <a (click)="closeMe('dynamic')">
                    <i class="far fa-times-circle"></i>
                  </a>
                </ng-template>
              </div>
            </div>
            <div class="m col agent_link">
                <p class="alert-text">
                    {{ message?.message_1 | translate }} 
                    <a href="{{ message?.link?.url }}" target="_blank">                      
                      {{message?.link?.text}}
                    </a>
                    {{ message?.message_2 | translate }}
                </p>
                
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noLink>
      <ng-container *ngFor="let alertTypeObject of alertTypeObjects">

        <ng-container *ngIf="!isAcmic && (alertTypeObject?.alertType === 'error' || alertTypeObject?.alertType === 'success'); else notErrOrSuccess">
          <ng-container *ngIf="message?.type === alertTypeObject?.alertType">
          <div class="notify-alert {{alertTypeObject?.className}}-bg" [ngClass]="{'alert-white-bg': message?.theme ==='white','no-title-notification':!message?.title?.length}">
            <div class="alert-icon {{alertTypeObject?.className}}-bg">
                <img src="./assets/SVG/icon-warning-{{alertTypeObject?.alertType}}.svg">
            </div>
            <div class="notify-alert-info {{alertTypeObject?.className}}-bg">
              <div class="notify-content"> 
                <div class="alert-info-text fs-16">
              
                  <div *ngIf="message?.title?.length" class="message-title">{{message?.title | translate}}</div>
                  <div class="noti-close-icon" *ngIf="closeButton">
                    <a (click)="closeMe('dynamic')">
                      <img src="./assets/img/images/icon-close-18.svg">
                    </a>
                  </div>
              
                </div>
                <!-- <div class="message-text">{{ message?.text | translate }} </div> -->
                 <div class="message-text" [innerHTML]="message?.text | translate" [ngClass]="{'fw-500':!message?.title?.length}"></div>
              </div>
            </div>
          </div>
        </ng-container>
        </ng-container>
        <ng-template #notErrOrSuccess>
          <ng-container *ngIf="isAcmic; else nonacmicpart">
            <ng-container *ngIf="loginPage; else otherPageAlert">
              <ng-container *ngIf="message?.type === alertTypeObject?.alertType">
                <div class="notify-alert-acmic {{alertTypeObject?.className}}-bg" [ngClass]="{'alert-white-bg': message?.theme ==='white'}">
                  <div class="alert-icon-acmic {{alertTypeObject?.className}}-bg">
                    <mapfre-icon [loginPageIcon]="true" iconClasses="{{alertTypeObject?.iconClass}}"
                    [alertType]="alertTypeObject?.alertType"></mapfre-icon>
                  </div>
                  <div class="notify-alert-info-acmic">
                    <div class="alert-info-text-acmic {{alertTypeObject?.className}}-bg-info-text {{alertTypeObject?.className}}-acmic-message">
                      <div *ngIf="message?.title?.length" class="font-weight-500">{{message?.title | translate}}</div>
                      <div class="unenroll-sub-text-acmic">{{ message?.text | translate }} </div>
                    </div>
                    <div class="close-button-acmic" *ngIf="closeButton">
                      <a (click)="closeMe('dynamic')">
                        <img alt="close icon" src="assets/SVG/icon-toast-close-acmic.svg">
                      </a>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #otherPageAlert>
              <ng-container *ngIf="alertTypeObject?.className==='error'; else notError">
                <ng-container *ngIf="message?.type === alertTypeObject?.alertType">
                  <div class="notify-alert-acmic {{alertTypeObject?.className}}-bg" [ngClass]="{'alert-white-bg': message?.theme ==='white'}">
                    <div class="alert-icon-acmic {{alertTypeObject?.className}}-bg">
                      <mapfre-icon [loginPageIcon]="true" iconClasses="{{alertTypeObject?.iconClass}}"
                      [alertType]="alertTypeObject?.alertType"></mapfre-icon>
                    </div>
                    <div class="notify-alert-info-acmic">
                      <div class="alert-info-text-acmic fs-16">
                        <div *ngIf="message?.title?.length" class="font-weight-500">{{message?.title | translate}}</div>
                        <div>{{ message?.text | translate }} </div>
                      </div>
                      <div class="close-button-acmic" *ngIf="closeButton">
                        <a (click)="closeMe('dynamic')">
                          <img alt="close icon" src="assets/SVG/icon-toast-close-acmic.svg">
                        </a>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #notError>
                <div class="mapfre alert {{alertTypeObject?.className}}"
                  [ngClass]="{'success-acmic':isAcmic && (alertTypeObject?.className==='success')}"
                  *ngIf="message?.type === alertTypeObject?.alertType">
                  <div class="notice-main-container">
                    <div class="icon col agent_link">
                      <ng-container *ngIf="message?.iconPath; else defaultAcmicAlertIcon">
                        <img [src]="message?.iconPath" alt="alert icon" />
                      </ng-container>
                      <ng-template #defaultAcmicAlertIcon>
                        <img src="./assets/SVG/icon-warning-{{alertTypeObject?.alertType}}.svg">
                      </ng-template>
                    </div>
                    <ng-container *ngIf="isAcmic && (alertTypeObject?.className==='success'); else nonSuccessScenario">
                      <div class="acmic-notify-container">
                        <div class="acmic-notify-content">
                          <div *ngIf="message?.title?.length" class="acmic-notify-title">{{message?.title | translate}}</div>
                          <!-- <div class="acmic-notify-messsage">{{ message?.text | translate }} </div> -->
                          <div class="acmic-notify-messsage" [innerHTML]="message?.text | translate" [ngClass]="{'fw-500':!message?.title?.length}"></div>
                        </div>
                        <div class="close-button" *ngIf="closeButton">
                          <a (click)="closeMe('dynamic')">
                              <img alt="close icon" src="./assets/img/images/icon-close-18.svg">
                          </a>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #nonSuccessScenario>
                      <div class="m col agent_link {{alertTypeObject?.className}}-acmic-message" [ngClass]="{'message-padding':isAcmic}">
                        <div *ngIf="message?.title?.length" class="acmic-notify-title">{{message?.title | translate}}</div>
                        <div class="unenroll-sub-text-acmic" [ngClass]="{'fw-500': !message?.title?.length}">
                          {{ message?.text | translate }} <a *ngIf="message?.type === 'renewal'" href='/contact'
                            class="blue-text fontWeight">{{'CONTACT_YOUR_AGENT' | translate}}</a>
                        </div>
                      </div>
                      <div class="close-button" *ngIf="closeButton">
                        <a (click)="closeMe('dynamic')">
                          <ng-container *ngIf="message?.iconPath; else acmicCloseFallback">
                            <img src="./assets/img/images/icon-close-18.svg" alt="close icon" />
                          </ng-container>
                          <ng-template #acmicCloseFallback>
                            <ng-container *ngIf="isAcmic; else maIconClose">
                              <img alt="close icon" src="assets/SVG/icon-toast-close-acmic.svg">
                            </ng-container>
                            <ng-template #maIconClose>
                              <i class="far fa-times-circle"></i>
                            </ng-template>
                          </ng-template>
                        </a>
                      </div>
                    </ng-template>
                
                  </div>
                </div>
              </ng-template>
            </ng-template>  
          </ng-container>
          <ng-template #nonacmicpart>
            <div class="mapfre alert {{alertTypeObject?.className}}" *ngIf="message?.type === alertTypeObject?.alertType">
             <div class="row a-cont">
               <div class="icon col agent_link">
                 <ng-container *ngIf="message?.iconPath; else defaultAlertIcon">
                   <img [src]="message?.iconPath" alt="alert icon" />
                 </ng-container>
                 <ng-template #defaultAlertIcon>
                   <mapfre-icon iconClasses="{{alertTypeObject?.iconClass}}"></mapfre-icon>
                 </ng-template>
               </div>
               <div class="m col agent_link">
                 <div *ngIf="message?.title?.length" class="message-title">{{ message?.title | translate }}</div>
                 <div class="unenroll-sub-text" [ngClass]="{'fw-500': !message?.title?.length}">
                   {{ message?.text | translate }} <a *ngIf="message?.type === 'renewal'" href='/contact'
                     class="blue-text fontWeight">{{'CONTACT_YOUR_AGENT' | translate}}</a>
                 </div>
               </div>
               <div class="close-button" *ngIf="closeButton">
                 <a (click)="closeMe('dynamic')">
                    <ng-container *ngIf="message?.iconPath; else defaultCloseIcon">
                      <img src="./assets/img/images/icon-close-18.svg" alt="close icon" />
                    </ng-container>
                    <ng-template #defaultCloseIcon>
                      <i class="far fa-times-circle"></i>
                    </ng-template>
                 </a>
               </div>
             </div>
           </div>
          </ng-template>
       
      </ng-template>
      </ng-container>
    </ng-template>
    <!-- </ng-template> -->
    </ng-template>

  </div>
</div>

<div *ngIf="nonDynamic" class="alert-container margin-top {{additionalClasses}}"
  [ngClass]="{'mt24': notTop === false }">
  <ng-container *ngFor="let alertTypeObject of alertTypeObjects">
    <ng-container *ngIf="alertType === alertTypeObject?.alertType">
      <div class="mapfre alert {{alertTypeObject?.className}} margin-bottom mb16">
        <div class="row a-cont">
          <div class="icon col">
            <mapfre-icon [showWanringIcon]="showWanringIcon" iconClasses="{{alertTypeObject?.iconClass}}"
            [alertType]="alertTypeObject?.alertType"></mapfre-icon>
          </div>
          <div class="m col">
            <ng-content></ng-content>
          </div>
          <div class="close-button" *ngIf="closeButton">
            <a (click)="closeMe('dynamic')">
              <ng-container *ngIf="isAcmic; else maIcon">
                <img alt="close icon" src="assets/SVG/icon-toast-close-acmic.svg">
              </ng-container>
              <ng-template #maIcon>
                <i class="far fa-times-circle"></i>
              </ng-template>
              
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>